module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modalWrapperHolder"
  }, _vm._l((_vm.getModalArray), function(modal, index) {
    return (modal.templateImport) ? _c(modal.templateImport, {
      key: index,
      tag: "component",
      staticClass: "modalWrapper"
    }) : _vm._e()
  }), 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-4d3719af", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d3719af"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/ModalWrapper.vue
// module id = 2375
// module chunks = 0